<template>
<div style="padding: 20px">
        <Tabs value="name1" >
            <TabPane label="账户信息" name="name1">
                <div style="width: 400px;margin: 30px">
                      <img class="logo" :src="imgdata" >
                      <Form  :label-width="80" style="padding-top: 50px">
                            <FormItem label="店铺名称:">
                                <Input  v-model="formValidate.name"  placeholder="店铺名字必填"></Input>
                            </FormItem>

                            <!-- 员工不可见 -->
                              <FormItem label="姓名:" v-if="isShowName==1">
                                  <Input  v-model="formValidate.username"  placeholder="请输入姓名(必填)"></Input>
                              </FormItem>
                          <FormItem label="地址:">
                              <Input  v-model="formValidate.address"  placeholder="详细地址必填"></Input>
                          </FormItem>
                            <FormItem label="电话:">
                                <Input  v-model="formValidate.tel"  placeholder="联系方式必填"></Input>
                            </FormItem>
                            <FormItem>
                                <Button type="primary" @click="saveMsg()">保存</Button>
                            </FormItem>
                        </Form>
                </div>
            </TabPane>
        </Tabs>
</div>
</template>
<script>
    export default {
        components: {},
        data () {
            return {
                cid:"",
                isShowName:JSON.parse(localStorage.getItem('adminUser')).type,
                formValidate: {
                    name: '',
                    tel: '',
                    address: '',
                    adminId:JSON.parse(localStorage.getItem('adminUser')).id,
                    username:JSON.parse(localStorage.getItem('adminUser')).name
                },
                imgdata:''
            }
        },

        created: function() {
            //DOM更新完之前请求数据
            this.cid= JSON.parse(localStorage.getItem('shop')).id
            this.$Api.getCompanyId({
                id: JSON.parse(localStorage.getItem("adminUser")).cid
            }).then(res => {
                if (res.code == 200) {
                    if(res.data.imgurl==''){
                        this.imgdata= require('../../assets/img/logo.png')
                    }else {
                        this.imgdata ="https://tangyingkeji.oss-cn-beijing.aliyuncs.com/tangyingkeji.oss-cn-beijing.aliyuncs.com" + res.data.imgurl;
                    }

                } else {
                    this.$Message.warning(res.msg);
                }
            });

            this.getShopId(this.cid)
        },
        methods: {
            getShopId(id){
                let data = {
                    id:id
                };
                this.$Api.getShopId(data).then(res => {
                    if(res.code==200){
                        this.formValidate.name =  res.data.name
                        this.formValidate.tel =  res.data.phone
                        this.formValidate.address =  res.data.address
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //更新
            saveMsg(){
                let data = {
                    id: this.cid,
                    phone: this.formValidate.tel,
                    address:  this.formValidate.address,
                    name:  this.formValidate.name,
                    adminId:this.formValidate.adminId,
                    adminName:this.formValidate.username
                };
                if(this.formValidate.name==''){
                    this.$Message.info('店铺名字不能为空');
                    return
                }
                if(this.formValidate.username=='' && this.isShowName==1){
                    this.$Message.info('姓名不能为空');
                    return
                }

                if(this.formValidate.tel==''){
                    this.$Message.info('联系方式不能为空');
                    return
                }
                if(this.formValidate.address==''){
                    this.$Message.info('地址不能为空');
                    return
                }
                this.$Api.updateShopAndAdmin(data).then(res => {
                    if(res.code==200){
                        this.getShopId(this.cid)
                        this.$Message.success('修改成功！');
                        var adminUser= JSON.parse(localStorage.getItem('adminUser'))
                        adminUser.name= this.formValidate.username
                        localStorage.setItem('adminUser',JSON.stringify(adminUser))
                        window.location.reload()
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

        }
    }
</script>


<style  lang="scss" scoped>
    .server-title{
        display: inline-block;
        text-align: center;width: 88%
    }
    .logo{
        width: 50px;
        height: 50px;
        margin: auto;
        border-radius: 50%;
    }
.ivu-form-item{
    height: 30px;
}
</style>